module.exports = __webpack_public_path__ + "img/pos-img2.1115815e.png";